import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider } from "@material-tailwind/react";
import "video-react/dist/video-react.css";
import "react-toastify/dist/ReactToastify.css";
import 'leaflet/dist/leaflet.css';
import 'mapbox-gl/dist/mapbox-gl.css';
import '@aerisweather/mapsgl/dist/mapsgl.css';
import { Provider } from "react-redux";
import { store, persistor } from "./store/store";
import { PersistGate } from "redux-persist/integration/react";
import Loader from "./Components/Loader";
import ErrorBoundary from "./Components/ErrorBoundary";
window.addEventListener("error", (event) => {
  console.log("event-----------",event)
  event.stopImmediatePropagation();
  event.preventDefault();
  console.error = () => {}
  if (event.message.includes("Cannot read properties of undefined")||event.message.includes("this.trigger is not a function")) {
    event.stopImmediatePropagation();
    event.preventDefault(); 
    console.error = () => {}; /// screen pe error na dikhaye
  }
});
window.addEventListener("unhandledrejection", (event) => {
  event.stopImmediatePropagation();
    event.preventDefault();
    console.error = () => {}
  if (String(event.reason).includes("Cannot read properties of undefined")||event.message.includes("this.trigger is not a function")) {
    event.stopImmediatePropagation();
    event.preventDefault();
    console.error = () => {}
  }
});
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <PersistGate loading={<Loader />} persistor={persistor}>
      <ThemeProvider>
       <App />
      </ThemeProvider>
    </PersistGate>
  </Provider>
);

reportWebVitals();
